module.exports = "<p>\n  logout works!\n</p>\n"